import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ name, className }) => {
  let classList = 'icon'
  classList += name ? ` icon-${name}` : ''
  classList += className ? ` ${className}` : ''

  return <span className={classList} />
}

Icon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
}

export default Icon
